/* Really a 'Doc-Slice */

var Marionette = require('marionette'),
    _ = require('underscore'),
    Backbone = require('backbone'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV'),
    Util = require('../../FV/util'),
    DocContainerFactory = require('./container/factory'),
    NotesCollection = require('../../notes/models/notes'),
    DocNotes = require('../../notes/models/document/documentNotes'),
    PgNotes = require('../../notes/models/page/pgNotes'),
    Pages = require('../models/page/pages'),
    ThumbNails = require('../models/page/thumbnails'),
    Indexes = require('../../index/model/indexCollection'),
    FullTextModel = require('../../fulltext/esModel/elasticSearchModel'), /* TODO: separate from document -- should be a setting and then put in the fulltext module*/
    ViewerSettings = require('../settings/settings'), //maybe just take the fn needed
    DocumentLockStatus = require('../../FV/documentLockStatus'),
    DocumentTextModel = require('./positionalTextModels/DocumentTextModel'),
    ContextualPermissionsModel = require('./contextualPermissions');


require('navigator.sendbeacon'); // May want to put this in FV.bootstrap under a 'polyfills' section (though woudn't work for testing this specifically)


var instanceProps = {

    pageCollection: {}, // note: the document mode pages
    thumbCollection: {},

    documentTextModel: null,

    allNotes: {},
    pgNotes: {},
    docNotes: {},

    docContainer: null,

    permissions: null,

    indexCollection: null, // server side treated as on the container -- but storing on the object; only set if they exist
    fullTextModel: null, /* will be created if settings has fullTextQuery in settings */
    docSlice: null, /* this is the container requested */
    vOptions: null

};


module.exports = Backbone.Model.extend({

    constructor: function(attrs, options) {

        _.extend(this, instanceProps);
        this.options = options;
        Backbone.Model.prototype.constructor.apply(this, arguments);

    },
    defaults: function() {
        return {
            docNumber: null, // now not used but set b/c could be handy -- now storing base 1 -- maybe superflous if stays in order -- can get from collection index; it's in the order requested
            openToPageNumber: 1,
            docHasNoPages: false, // flag that no pages in doc -- used to disable lots of things; noPages view replaces other view modes
            docHasNoRenderablePgs: false, //flag: true if no pages renderable -- pdf mode doesn't launch pdf viewer -- lists the pages; other modes show as unrenderable
            //TODO: could also disable thumbs, doc pgs, and single pg mode (like in no pages)
            docHasSomeUnrenderablePgs: false, // for pdf mode header download dd -- indicates that some, but not all pages are unrenderable
            shouldLoadPDF: true
        };
    },
    parse: function(resp, options) {

        var pages = resp.pages,
            imgFileType = options.imageFileType;

        // resp.container will be null if user doesn't have necessary permissions, BUT:
        // this should never occur (so now not checking); if the user has perm to view the doc, they have can view info about the container
        // with virtual fcs, the user should have access to the virtual but not the base fc
        // if issue, could get container types and ids from the doc request now stored here (or have server send it regardless)
        this.docContainer = new DocContainerFactory( resp.container );

        this.permissions = new ContextualPermissionsModel( resp.permissions );

        var pgOpts = {
            parse: true,
            parentDocument: this,
            imageFileType: imgFileType
        };

        // Allow for pages to reference their parent document ( collection.parentDocument )
        // TODO: docModeImageWidthFn
        // - pass from the channel requests ( fn from channel / store elsewhere ); perhaps derivable from pg attributes
        // - we may be able to remove now -- don't take consideration of the container width into account for derived doc mode width
        this.pageCollection = new Pages( pages, _.extend( pgOpts, {
            docModeImageWidthFn: options.docModeImageWidthFn
        }));



        if ( this.hasPagesWithPositionalData() ) {

            this.documentTextModel = new DocumentTextModel().create( this );

        }

        /**
         * DVBC-1823 - always create the thumbnails collection even if we don't include the thumbnails module ( eg if thumbs are disabled ).
         * We could stop doing this but processing time is negligible and removing this entirely is error prone.
         */
        this.thumbCollection = new ThumbNails( pages, pgOpts );

        this.docNotes = new DocNotes( resp.documentNotes, {
            parse: true,
            allowFlashNotes: options.allowFlashNotes,
            document: this // used for the url of the document note model, collection
        } );

        // Page Notes must come after the pageCollection is set, it's now referenced on parse of the pageNote model
        this.pgNotes = new PgNotes( options.includePageNotes ? resp.pageNotes : [], {
            parse: true,
            document: this,
            pageCollection: this.pageCollection // now necessary to parse page notes
        });

        // Set the index collection if there are fields ( terminology interchangable with indexes currently ).
        // Doing even if option to not include indexes is set -- this won't affect anything, plus will need index values to derive file names.
        if ( this.docContainer.hasFields() )
            this.indexCollection = new Indexes( this.docContainer.getFields() );


        /* -- old sync finish start -- */

        if ( this.hasPages() && this.pgNotes.length > 0 ) {

            this.pgNotes.setPageNumbers( this.pageCollection );

            // Also store collection of pageNotes for each page on the pageObject.
            // TODO: this has proven problematic -- change it to get one source of truth.
            this.pageCollection.each( function(p) {

                var notesOfPage = this.pgNotes.getNotesOfPage(p);

                p.setNoteCollection( notesOfPage );

                /**
                 * Also set on the corresponding thumbnail.
                 * Now only utilized for note info (reason codes) in page info dialog but could later prove beneficial.
                 * May be more elegant way of sharing the references across page and thumbnail models.
                 */
                this.thumbCollection.findWhere( {number: p.get('number')} ).setNoteCollection( notesOfPage ) ;

            }, this);

        }

        this.allNotes = new NotesCollection( this.pgNotes.models.concat( this.docNotes.models ), {
            document: this
        });

        /* -- old sync finish end -- */


        /* Note: isRenderable set on init of the pages */
        //determine whether the document has any renderable pages & set flag (or some, for PDF mode)

        var hasNoPgs = pages.length < 1,
            hasNoRenderablePgs = this.pageCollection.noRenderablePagesExist(),
            hasSomeRenderablePgs = this.pageCollection.someRenderablePagesExist(),
            hasNoPDFRenderablePgs = this.pageCollection.noPDFRenderablePagesExist(),
            hasSomePDFRenderablePgs = this.pageCollection.somePDFRenderablePgsExist();

        return _.extend( resp, {
            docHasNoPages: hasNoPgs,   // flag & evt trigger to indicator no pages in doc -- used to disable lots of things
            // setting to true will create the 'Doc has no pages view' over the center content
            //not sure if still need these, those that defined what's used in pdf mode now driven by combo with url page (below)
            docHasNoRenderablePgs: hasNoRenderablePgs,  // flag: set to true if no pages are renderable -- if so: PDF mode is disabled
            docHasSomeUnrenderablePgs: hasSomeRenderablePgs,
            docHasNoPDFRenderablePgs: hasNoPDFRenderablePgs,
            docHasSomePDFRenderablePgs: hasSomePDFRenderablePgs,
            shouldLoadPDF: !hasNoPgs && !hasNoPDFRenderablePgs /* flag to determine whether to trigger loading of pdf from outside its view */
        });

    },
    /*
    * Set properties that can't be done in parse because they require the index of the model in the collection.
    * Must be called immediately post a successful doc info fetch.
    * Simpler than override documents.fetch to return the original jqXHR post changing the model attrs.
    * Better solution would be to send the number in the server response.
    * */
    setPropertiesPostParse: function(options) {

        var docIndex = this.collection.indexOf( this.collection.get(this) );

        this.docSlice = this.collection.docSlices[docIndex];
        this.vOptions = this.collection.vOptions[docIndex];

        this.set({
            docNumber: docIndex, //could be superflous
            openToPageNumber: this._determinePgNumToOpenTo(options.viewerLevelOpenToPageNumber)
        }, {silent: true});

    },
    _determinePgNumToOpenTo: function(viewerLevelOpenToPageNumber) {

        var lastPageNumber = Math.max.apply( null, this.pageCollection.pluck('number') ); //could cache this

        //if defined and not valid, it was set to the default
        var vOptionPgNumber = this.vOptions && this.vOptions.openToPageNumber
            ? ViewerSettings.prototype.getValidatedOpenToPageNumber(this.vOptions.openToPageNumber) //could argue that if invalid and the instance var is set, use that
            : undefined;

        var userProvidedPgToOpenTo = vOptionPgNumber
            ? vOptionPgNumber
            : viewerLevelOpenToPageNumber;  //viewerLevelOpenToPageNumber is already validated (less knowing number of pages in the document)

        //Validation to be performed after we know the # of pages in the doc
        (userProvidedPgToOpenTo === 'last') && (userProvidedPgToOpenTo = lastPageNumber);

        var pgNumToOpenTo = userProvidedPgToOpenTo > lastPageNumber
            ? lastPageNumber
            : userProvidedPgToOpenTo;

        return pgNumToOpenTo;

    },
    getPageToOpenTo: function(options) {
        
        var pgNumToOpen = options && options.pgNumberToOpenTo
            ? getValidatedPgNumToOpen.call(this, options.pgNumberToOpenTo)
            : this.get('openToPageNumber');

        return this.pageCollection.findWhere({number: pgNumToOpen});

        function getValidatedPgNumToOpen(pgNumberToOpenTo) {

            //shouldn't happen, only called if has pages in workflow
            if ( this.get('docHasNoPages') )
                return 0;

            var lastPgNum = Math.max.apply(null, this.pageCollection.pluck('number'));

            /* if the prior active page number > than number of pages, go to the last page */
            if ( pgNumberToOpenTo > lastPgNum )
                return lastPgNum;

            /* the prior active page # exists, go to it */
            return pgNumberToOpenTo;
        }

    },

    /**
     * Called post successful docInfo fetch.
     * This used to contain a number webservice calls utilizing the async queue library.
     * Those have now all been combined in the docInfo object and logic from here has been
     * moved to parse of this model.
     * Sole remaining is the full-text query, which we may want to get rid of now that we have
     * implemented a text layer.
     */
    fetchData: function(options, cbCxt) {

        var self = this;
        cbCxt = cbCxt ? cbCxt : this;

        return $.Deferred(function($dfd) {

            /**
             * WF for FT 2, forced in here for now ....
             * (Allow for empty string values: default is null -- is never undefined in viewer settings)
             */
            if ( typeof options.fullTextQuery === 'string' ) {

                /**
                 * Allow to set later, always created (otherwise errMsg will be incorrect ).
                 * Also current wf runs query when FV.fullTextModel (which here is always), which calls the query -- so need something set
                 */
                var ftm = self.fullTextModel = new FullTextModel([], {
                    searchText: options.fullTextQuery,
                    docId: self.get('docId'),
                    fetchUrl: fvChannel.request('esURL')
                });

                ftm.fetch().always( function() {
                    $dfd.resolveWith(cbCxt);
                });


            } else {
                $dfd.resolveWith(cbCxt);
            }


        }).promise();

    },

    hasPages: function() {
        return this.pageCollection && this.pageCollection.length > 0;
    },

    hasNotes: function() {
        return this.allNotes && this.allNotes.length > 0;
    },

    hasIndexes: function() {
        return this.indexCollection && this.indexCollection.length > 0;
    },
    /*
    *  Return the derived 'name' of the document.
    *  If fileExtension provided, add it to the end.
    *  If forDownload is provided, ensure the file name is properly url and 'file-system' escaped.
    *  Note: page-less document downloads are blocked in the UI.
    * */
    documentName: function(fileExtension, forDownload) {

        var name = this._getNameWithoutFileExtension(fileExtension);

        if (fileExtension)
             name += '.' + fileExtension;

        if (forDownload) {
            // Note: Url Escaping
            // - file names with download URLs going to the CRE are already url sanitized in the jQuery CRE plugin.
            // - file names not set with requests for big gos files (and these are set through the page request)
            name = Util.sanitizeFileNameForFileSystem(name);
        }

        return name;

    },
    /*
    * Return the derived document name without an extension.
    * Exception for special case:
    * return the file extension for documents whose first page is GOS when fileExtensionRequested is not defined.
    * */
    _getNameWithoutFileExtension: function(fileExtensionRequested) {

        // If document has pages and the first page is GOS and gosInfo.fileName is set), return gosInfo.fileName.
        // Applies to documents in File Cabinet and Bin containers
        var pgs = this.pageCollection,
            firstPgGosFileName = (pgs.length > 0) && pgs.at(0).gosInfoFileName();

        if ( firstPgGosFileName )
            return fileExtensionRequested
                ? Util.stripFileExtension( firstPgGosFileName )
                : firstPgGosFileName;

       return this.getNonGosNameWithoutExtension();

    },
    /*
    * Used in getting document and page names for non-GOS page types.
    * */
    getNonGosNameWithoutExtension: function() {

        var docContainer = this.docContainer.getType(),
            name;

        if (docContainer === 'FILECABINET') {

            var indexes = this.indexCollection;

            if ( indexes && indexes.length > 0 ) {

                var firstIndexValue = indexes.firstIndexValue(1);

                if (firstIndexValue && firstIndexValue.length > 0)
                    name = firstIndexValue;
            }

        }
        else if (docContainer === 'BIN') {

            // docName is really doc_info.title (the 'batch' title) -- I have no idea why it was named that way on the server
            name = this.get('docName');

        }

        // If either is not defined, return the doc_id;
        return name
            ? name
            : this.getId();

    },

    docRenderRequest: function(contType, pgType) {

        var defaultRequestForThisDoc = {
                renderRequest: {
                    renderingParameters: {
                        containerType: contType,
                        pageType: pgType // could implement default image fmt -- for now jpg
                    },
                    slices: [ this.getDocSliceForRenderRequest() ],
                    destinations: {
                        allowDownload: true
                    }
                }
            };


        return defaultRequestForThisDoc;

    },

    // could now map to getSlice() ...
    getDocSliceForRenderRequest: function() {

        var INCLUDE_NOTES = 1; // TESTING
        if (PRODUCTION) {
            INCLUDE_NOTES = 0;
        }


        return {
            documentAddress: this.docAddress(),
            perPageFddImageParameters: getPerPageImageParameters.call(this),
            pageNotesByType: INCLUDE_NOTES
                ? ['REDACTION_NOTE', 'GRAPHIC_NOTE', 'HIGHLIGHT_NOTE', 'GRAPHIC_STAMP', 'INITIALS', 'SIGNATURE',
                'SVG_SIGNATURE', 'SVG_GRAPHIC_NOTE', 'STRIKE_THROUGH', 'FLOATING_REDACTION_NOTE', 'FULL_PAGE_REDACTION', 'GRAPHIC_TEXT_STAMP' ]
                : []
        };


        /**
         * Now always request pages without rotation because users may not have save rotation permission.
         * Always ask un-rotated and then rotate by the page rotation value, which is set on load and when the
         * pages are rotated.
         * Potentially only add this if the user lacks rotation permission?
         */
        function getPerPageImageParameters() {

            var perPageImageParams = {};

            this.pageCollection.forEach( function(p) {

                perPageImageParams[ p.get('pageId') ] = {
                    disableFddRotation: true,
                    rotation: p.get('rotation')
                };

            });

            return perPageImageParams;

        }

    },

    getFileExtension: function(isPDF) {
        var ext;
        if (this.pageCollection.length > 1) { //if multi-page
            ext = isPDF ? 'pdf' : 'zip';
        } else {
            // for 1 pg use the file extension, not zip (pdf always pdf)
            // latter getting from the first page, ( request container is for 'raw' for a 'download', not zip -- so CRE returns one page )
            ext = isPDF ? 'pdf' : this.pageCollection.at(0).getFileNameExtension();
        }
        return ext;
    },


    docIndexes: function() {
        return this.indexCollection;
    },
    getId: function() {
        return this.get('docId');
    },
    // container related:
    //TODO: handle if no in there (and for others)... maybe on server always fill in type and id -- don't need perm for this ...
    // aimee says shouldn't be the case that can view the doc but not the container info -- test on virtual
    docAddress: function() {
        return {
            containerType: this.docContainer.getType(),
            containerId: this.docContainer.getId(),
            documentId: this.getId()
        };
    },
    getDocContainer: function() {
        return this.docContainer;
    },
    getContainerType: function() {
        return this.docContainer.getType();
    },
    friendlyContainerType: function() {
        return this.docContainer.getFriendlyTitle();
    },
    getContainerId: function() {
        return this.docContainer.getId();
    },
    getContainerIcon: function() {
        return this.docContainer.getIcon();
    },
    containerTitle: function() {
        return this.docContainer.getTitle();
    },
    getDocSlice: function() {
        return this.docSlice;
    },

    //TODO: combo ... --------------
    docHasSomeUnrenderablePgs: function() { //TODO: use this instead of call on the pages
        return this.get('docHasSomeUnrenderablePgs');
    },
    docHasNoRenderablePgs: function() {
        return this.get('docHasNoRenderablePgs');
    },
    docHasNoPDFRenderablePgs: function() {
        return this.get('docHasNoPDFRenderablePgs');
    },
    docHasSomePDFRenderablePgs: function() {
        return this.get('docHasSomePDFRenderablePgs');
    },
    //-------------
    shouldLoadPDF: function() {
      return this.get('shouldLoadPDF');
    },
    hasRenderablePgs: function() {
        return this.hasPages() && !this.docHasNoRenderablePgs();
    },
    resetLoadStateOfAllPgs: function() {
        this.pageCollection.invoke('resetLoadState');
        this.thumbCollection.invoke('resetLoadState');

    },

    deletePages: function(aPages, cxt) {
        // could double-check if the pages are deletable on the model function (if pass that in);
        // now just using the UI to prevent which should suffice
        var url = fvChannel.request('apiUrl').deletePages(this);

        return $.Deferred(function($dfd) {
            /* note: stringify'd body required for express to read req body */
            $.ajax({
                url: url,
                type: 'DELETE',
                context: cxt ? cxt : this,
                //array of object consisting seq, pageId
                data: JSON.stringify(_.map( aPages, function(p) {
                    return {
                        seq: p.get('seq'), //sequence all that's really needed for the operation
                        pageId: p.get('pageId'), //not needed but can't hurt -- now used to identify pages that failed
                        pageNumber: p.get('number') //may want to start using in success/error messages instead of pageId
                    };
                }))
            }).done( function( data ) {
                // data returned is array of obj with pageId, seq, errorMessage
                // parse the data and just return obj for help displaying as success/error message (or combo)
                /* [ {"pageId": 1149131, "errorMessage": null }]*/

                $dfd.resolveWith( this, [{
                    successfulPages: _.filter( data, function(d) {
                        return d.errorMessage === null;
                    }),
                    errorPages: _.filter( data, function(d) {
                        return d.errorMessage !== null;
                    })
                }] );

            }).fail( function(jqXHR) {
                //Note: this would be entire failure, we are making a batch request and individual errors will be reported in successful respp
                $dfd.rejectWith( this, [jqXHR] );
            } );

        }).promise();
    },

    addPages: function( fileList, insertAtPgNum ) {

        var url = fvChannel.request('apiUrl').addPages( this, insertAtPgNum ),
            formData = new FormData();  //Note: FormData only works IE10+, given OK for this !!!

        _.each( fileList, function(f) {
            formData.append( 'files', f );
        });

        return $.Deferred(function($dfd) {
            $.ajax({
                url: url,
                type: 'POST',
                contentType: false, // // Set content type to false as jQuery will tell the server its a query string request ( really: 'multipart/form-data' )
                processData: false, // Important!: don't process the files
                data: formData
            }).done( function( pages ) {
                $dfd.resolve( pages );
            }).fail( function(jqXHR) {
                $dfd.reject( jqXHR );
            } );
        }).promise();

    },

    reorderPages: function(pgsToMove, destinationPg, insertAfter) {

        var pgs = this.pageCollection,
            self = this;

        return $.Deferred(function($dfd) {
            $.ajax({
                url: fvChannel.request('apiUrl').reorderPages( self ),
                type: 'PUT',
                data: JSON.stringify( {
                    pages: _.map( pgsToMove, function(p) {
                        var pg = pgs.findWhere( {number: p });
                        return {
                            seq: pg.get('seq'),
                            pageId: pg.get('pageId'),
                            pageNumber: pg.get('number')
                        };
                    }),
                    destSeq:  pgs.findWhere({ number: destinationPg }).get('seq'),
                    after: insertAfter
                } )
            }).done( function( data ) {
                $dfd.resolve( data );
            }).fail( function(jqXHR) {
                $dfd.reject( jqXHR );
            } );

        }).promise();

    },
    /*
     * Check Document Lock Status.
     * Wrap successful resp to return DocumentLockStatus model.
     * */
    checkLockStatus: function(context) {

        var cxt = context || this,
            url = fvChannel.request('apiUrl').lockStatus( this );

        return $.Deferred(function($dfd) {

            $.ajax({
                url: url,
                type: 'GET',
                context: cxt
            }).done( function( resp ) {
                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
            } ).fail( function( jqXHR ) {
                $dfd.rejectWith( cxt, [jqXHR ] );
            });

        }).promise();

    },
    /*
     * Attempt to lock the document.
     * Wrap successful resp to return DocumentLockStatus model.
     * */
    lock: function(context) {

        var cxt = context || this,
            url = fvChannel.request('apiUrl').lockDocument( this );

        return $.Deferred(function($dfd) {

            $.ajax({
                url: url,
                type: 'POST',
                context: cxt
            }).done( function( resp ) {
                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
            } ).fail( function( jqXHR ) {
                $dfd.rejectWith( cxt, [jqXHR ] );
            });

        }).promise();

    },
    /*
    * Attempt to unlock the document.
    * Wrap successful resp to return DocumentLockStatus model.
    * Force: optional -- if provided & true, unlock regardless of the user who currently holds the lock;
    * if false, will only succeed if the user is the one who currently holds the lock.
    * Synchronous: perform a synchronous request; useful if call on window unload. -- may rid if use sendBeacon polyfil
    * Note: if sync employed, jqXHR methods are deprecated in favor of success/error/complete callbacks.
    * */
    unlock: function( force, context, synchronous ) {

        var cxt = context || this,
            url = fvChannel.request('apiUrl').unlockDocument( this, force ),
            async = synchronous ? false : true; //

        return $.Deferred(function($dfd) {

            $.ajax({
                url: url,
                type: 'POST',
                context: cxt,
                async: async
            }).done( function( resp ) {
                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
            } ).fail( function( jqXHR ) {
                $dfd.rejectWith( cxt, [jqXHR ] );
            });

        }).promise();

    },
    /*
    * Unlock with the navigator.sendBeacon API (or polyfill that falls back to a sync ajax post -- IE).
    * Note: send empty string (even though it's not necessary) to avoid run time error in the polyfill
    * that occurs in IE9 when checking the data argument for a Blob type  ( the check routine
    * exits before if a string is passed).
    * If sendBeacon fails for any reason, fallback with already written ajax unlock call with a sync option
    * ( unlikely this would happen but a good failsafe -- sendBeacon only queues the request ).
    * */
    unlockWithBeacon: function() {
        var success = navigator.sendBeacon( fvChannel.request('apiUrl').unlockDocument( this ), ''  );
        if (!success)
            this.unlock(0, this, 1);
    },

    hasMultipartGosPages: function() {
        return this.pageCollection.hasMultipartGosPages();
    },

    isOnePageMultiPartGosSkeleton: function() {
        return this.pageCollection.length === 1 && this.pageCollection.at(0).isMultipartGosSkeleton();
    },

    // Returns whether the document can be download.
    // isPDF: if provided, isPDF implies via the CRE, otherwise raw.
    isDownloadable: function(isPDF) {

        if ( this.get('docHasNoPages') )
            return false;

        // DVBC-1704 -- hack: special logic for document with only URL pages,
        // which currently are considered 'renderable', but shouldn't be downloadable.
        if ( this.pageCollection.allPagesAreUrlPages() )
            return false;


        if (isPDF)
            return this.hasRenderablePgs(); // ( unrenderable includes multipart-GOS )


        // Original:

        // Only downloads of documents with multi-part-gos-page types if they contain one pg and it's the skeleton --
        // we are assuming that to be the case for documents created with these page types
        if ( this.hasMultipartGosPages() )
            return this.isOnePageMultiPartGosSkeleton();

        return true;
    },

    // ---- Perms ----

    allowAddPages: function() {
        return this.permissions.canAddPages();
    },

    allowDeletePages: function() {
        return this.permissions.canDeletePages() && !this.get('docHasNoPages');
    },

    // (need at least 1 page to reorder)
    allowReorderPages: function() {
        return this.pageCollection.length > 1 && this.permissions.canReorderPages();
    },

    // Rotate is really 'Allow to Save Rotation' -- don't disable the button b/c of it
    allowRotatePages: function() {
        return !this.get('docHasNoPages');
    },

    allowSaveRotation: function() {
        return this.permissions.canSavePageRotation();
    },

    allowCreatePgNote: function() {
        return this.permissions.canCreatePageNotes();
    },

    allowCreateDocNote: function() {
        return this.permissions.canCreateDocNotes();
    },
    allowModifyOrDeleteNote: function() {
        return this.permissions.canModifyOrDeleteNotes();
    },
    allowCreateHighlight: function() {
        return this.permissions.canCreateHighlights();

    },
    allowModifyOrDeleteHighlight: function() {
        return this.permissions.canModifyOrDeleteHighlights();
    },


    /** --- Positional Text Data: want to think of the words at the document level now --- */

    hasPagesWithPositionalData: function() {

        return this.pageCollection.find( function(p) {
                return p.hasPositionalTextData();
            }) !== undefined;

    },

    fddImagePagesExistAndAllHavePositionalData: function() {

        var fddImagesPages = this.pageCollection.filter( function(p) {
            return p.isFddImage();
        });

        if ( fddImagesPages.length < 1 ) {
            return false;
        }

        return _.every( fddImagesPages, function(p) {
            return p.hasPositionalTextData();
        } );

    },

    getDocumentTextModel: function() {
        return this.documentTextModel;
    },

    // X-ref btn getDerivedWordModels subwords and their originals
    // Could use cleanup but no longer used
    getOriginalWordModelByIdFromPageDataModels: function( docLevelWdId ) {

        var pagesWithPositionalData = this.pageCollection.pagesWithPositionalData();

        if (!pagesWithPositionalData || pagesWithPositionalData.length < 1)
            return null;

        // actually we want a fn that return all the words from the page objects for this ...
        // Need to search them all .... bummer ... just store the models directly ???

        for ( var i=0; i< pagesWithPositionalData.length; i++) {

            var pageTextData = pagesWithPositionalData[i].getPositionalTextDataModel();
            var words = pageTextData.words;
            var word = words.get( docLevelWdId );

            if (word)
                return word;

        }

    },


    /* --- End positional text data -- */


    onDestroy: function() {
        _.each( _.keys(instanceProps), function(p) {
            Marionette.blindTriggerOn(this[p], 'destroy');
            this[p] = null;
        }, this);
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/document.js
 ** module id = 392
 ** module chunks = 0
 **/